import styles from "./AssessmentProcess.module.scss";
import { MessageIcon } from "@/pages/MainPage/ui/assets/icons/message-icon";
import { ClockIcon } from "@/pages/MainPage/ui/assets/icons/clock";

export const AssessmentProcess = () => {
    return (
        <div className={styles.AssessmentProcess}>
            <div className={styles.title}>
                What is the consultation process?
            </div>
            <div className={styles.content}>
                <div className={styles.step}>
                    <div className={styles.iconsWrapper}>
                        <div className={styles.iconCheck} />
                        <div className={styles.iconLine} />
                    </div>
                    <div>
                        <div className={styles.stepTitle}>Step 1</div>
                        <div className={styles.stepText}>
                            <strong>Filling out the form.</strong>
                        </div>
                    </div>
                </div>
                <div className={styles.step}>
                    <div className={styles.iconsWrapper}>
                        <div className={styles.iconCheck} />
                        <div className={styles.iconLine} />
                    </div>
                    <div>
                        <div className={styles.stepTitle}>Step 2</div>
                        <div className={styles.stepText}>
                            <strong>Dr. Torsunov evaluates</strong> your
                            condition using his own unique method.
                        </div>
                    </div>
                </div>
                <div className={styles.step}>
                    <div className={styles.iconsWrapper}>
                        <div className={styles.iconCheck} />
                        <div className={styles.iconLine} />
                    </div>
                    <div>
                        <div className={styles.stepTitle}>Step 3</div>
                        <div className={styles.stepText}>
                            <strong>Our manager contacts</strong> you to confirm
                            the date and time of your consultation.
                        </div>
                    </div>
                </div>
                <div className={styles.step}>
                    <div className={styles.iconsWrapper}>
                        <div className={styles.iconCheck} />
                    </div>
                    <div>
                        <div className={styles.stepTitle}>Step 4</div>
                        <div className={styles.stepText}>
                            <strong>
                                During your consultation, our specialist
                            </strong>{" "}
                            will identify your specific type of tension, explain
                            which area of your life it affects, and create a
                            personalized wellness plan for you.
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.format}>
                <div className={styles.borderBlock}>
                    <div className={styles.formatIconsWrapper}>
                        <MessageIcon />
                    </div>
                    <div className={styles.borderText}>
                        Format: <span>Videocall</span>
                    </div>
                </div>
                <div className={styles.borderBlock}>
                    <div className={styles.formatIconsWrapper}>
                        <ClockIcon />
                    </div>
                    <div className={styles.borderText}>
                        Duration: 1 hour <span>+ 15 min</span>
                    </div>
                </div>
                <div className={styles.borderText}>
                    <span>+ 15 min</span>
                </div>
            </div>
            <div className={styles.notAll}>
                <div className={styles.notAllTitle}>That's not all...</div>
                <ul className={styles.notAllList}>
                    <li className={styles.notAllListItem}>
                        Our consultants <strong>stay in touch</strong> with you{" "}
                        <strong>for the next 30</strong>
                        days
                    </li>
                    <li className={styles.notAllListItem}>
                        <strong>Daily support</strong>
                    </li>
                    <li className={styles.notAllListItem}>
                        Possibility of an{" "}
                        <strong>additional consultation</strong> with a
                        specialist to reinforce your result.
                    </li>
                </ul>
            </div>
        </div>
    );
};
